import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import clsx from 'clsx';
import { propArrayShape, propStr, } from '../../../../../../../helpers/custom-prop-types';
import SharedMemberTooltip from './SharedMemberTooltip';
const SharedMembers = (props) => {
    const { className, members, title } = props;
    return (_jsxs("div", Object.assign({ className: clsx('proffit_search_folder_share_member', className) }, { children: [_jsx("div", Object.assign({ className: 'member_title' }, { children: title })), _jsx(SharedMemberTooltip, { className: 'member_count', members: members })] })));
};
SharedMembers.propTypes = {
    className: propStr(),
    members: propArrayShape().isRequired,
    title: propStr().isRequired,
};
SharedMembers.defaultProps = {
    className: '',
};
export default SharedMembers;
